var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"icon":"","small":""},on:{"click":function($event){return _vm.handleRemove()}}},[_c('v-icon',{attrs:{"small":"","color":"error"}},[_vm._v("mdi-delete")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }